export type QueryKeyType = [string, string | null];

export const getIntercomUserJwtKey = (userId: string | null): QueryKeyType => [
  "intercomUserJwt",
  userId,
];

export default getIntercomUserJwtKey;
